module.exports = __webpack_public_path__ + "static/headshot-milan-shah-2x.db627cce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-milan-shah-2x.jpg
// module id = 528
// module chunks = 152909308826437